export enum creditTypeEnum {
  certificate= 'certificate',
  message= 'message',
  event= 'event',
  update= 'update'
};

export enum creditNameToType {
  certificate= 0,
  message= 1,
  event= 2,
  update= 3
};
